import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Logo } from "../components/Header";
import { Field } from "./Checkout";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="mb-8 flex flex-col items-center text-center">
        <Logo size="h-24 w-24" />
        <h1 className="mt-6 text-4xl">Owner Login</h1>
        <p className="font-script text-lg text-[var(--pink)]">Manage your sweet shop</p>
      </div>
      <form onSubmit={submit} className="panel space-y-5 p-6" data-testid="admin-login-form">
        <Field label="Email"><input required type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></Field>
        <Field label="Password"><input required type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></Field>
        {error && <p className="text-sm font-bold text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn-candy w-full" data-testid="admin-login-submit-button">{busy ? "Signing in..." : "Sign in"}</button>
      </form>
    </div>
  );
}
